/* iVUE build-out page kit JS (P0 Task 5, 2026-10-09). Vanilla, deferred, no dependencies.
   Kit · Q&A: in-page filter (matches question + answer text, opens matches, hides empty groups, live count),
   and deep links: #anchor opens that answer and scrolls to it (existing help anchors keep working). */
(function () {
  'use strict';
  var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); };

  function initQa(root) {
    var input = root.querySelector('[data-kit-qa-input]');
    var count = root.querySelector('[data-kit-qa-count]');
    var none = root.querySelector('[data-kit-qa-none]');
    var items = [].slice.call(root.querySelectorAll('[data-kit-qa-item]'));
    var groups = [].slice.call(root.querySelectorAll('[data-kit-qa-group]'));
    var index = items.map(function (el) { return norm(el.textContent); });
    if (!input) return;
    var t;
    function run() {
      var q = norm(input.value), words = q ? q.split(' ') : [], shown = 0;
      items.forEach(function (el, i) {
        var hit = words.every(function (w) { return index[i].indexOf(w) !== -1; });
        el.hidden = !hit; el.classList.toggle('is-hit', !!q && hit);
        if (q) el.open = hit && shown < 3; // open the first few matches only
        if (hit) shown++;
      });
      groups.forEach(function (g) { g.hidden = !g.querySelector('[data-kit-qa-item]:not([hidden])'); });
      if (none) none.hidden = shown > 0;
      if (count) count.textContent = q ? shown + (shown === 1 ? ' answer' : ' answers') : '';
      if (!q) items.forEach(function (el) { el.open = false; });
    }
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 80); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; run(); } });
  }

  function openHash() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var el = document.getElementById(id);
    if (!el || !el.matches('[data-kit-qa-item]')) return;
    el.hidden = false; el.open = true;
    var g = el.closest('[data-kit-qa-group]'); if (g) g.hidden = false;
    requestAnimationFrame(function () { el.scrollIntoView({ block: 'start' }); });
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-kit-qa]'), initQa);
    openHash();
    window.addEventListener('hashchange', openHash);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
